import { useEffect } from 'react';
import { TooltipProvider } from '@components/ui/tooltip';
import { Pages } from '@constants/pages';
import ChatPage from '@pages/chat-page/chat-page';
import { DisclaimerPage } from '@pages/disclaimer-page';
import { NotFound } from '@pages/not-found';
import PDFViewer from '@pages/pdf-viewer/pdf-viewer';
import { TopicPickerPage } from '@pages/topic-picker-page';
import { VideoViewer } from '@pages/video-viewer';
import ChatProvider from '@stores/providers/chat-provider';
import ConversationProvider from '@stores/providers/conversation-provider';
import ThemeProvider from '@stores/providers/theme-provider';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import '@iframe-resizer/child';
import './styles/index.css';

function App() {
  const { t } = useTranslation();

  useEffect(() => {
    window.iFrameResizer = {
      onReady: () => console.info('iframe-resizer is ready'),
    };
  }, []);

  useEffect(() => {
    document.title = t('common.document_title');
  }, [t]);

  return (
    <ConversationProvider>
      <ThemeProvider>
        <ChatProvider>
          <TooltipProvider>
            <Routes>
              <Route path="/instance/:instance" element={<ChatPage />} />
              <Route
                path={`/instance/:instance${Pages.PDFViewer}/:docId`}
                element={<PDFViewer />}
              />
              <Route
                path={`/instance/:instance${Pages.VideoViewer}/:docId`}
                element={<VideoViewer />}
              />
              <Route path={`${Pages.PDFViewer}/:docId`} element={<PDFViewer />} />
              <Route path={`${Pages.VideoViewer}/:docId`} element={<VideoViewer />} />
              <Route path={Pages.Chat} element={<ChatPage />} />
              <Route path={Pages.Disclaimer} element={<DisclaimerPage />} />
              <Route path={Pages.TopicPicker} element={<TopicPickerPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </TooltipProvider>
        </ChatProvider>
      </ThemeProvider>
    </ConversationProvider>
  );
}

export default App;
